var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgUserDark = function SvgUserDark(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x36_4px_boxes"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Production"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#565D64",
    d: "M44.9519,17.3488c-0.3877-7.0434-5.9601-12.3546-12.9617-12.3546 c-6.9998,0-12.5731,5.3112-12.9619,12.3541C17.8044,39.5299,46.1772,39.5546,44.9519,17.3488z M23.9354,17.6263 c0.5631-10.2023,15.5474-10.1841,16.1095,0C40.887,32.8645,23.0923,32.8803,23.9354,17.6263z M31.9883,36.997 c-14.1914,0-22.5533,5.2706-23.5503,14.8784L7.9895,57c0.6959,0,4.0676,0,4.9274,0c0.4595-5-0.6998-15.0155,19.0714-15.0155 C51.4369,41.9845,50.5635,51,51.0635,57c0.7705,0,4.1848,0,4.9275,0C55.5107,52,56.574,36.997,31.9883,36.997z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgUserDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-dark.08367e2997f34db816b6abbbe803576e.svg";